import axios from 'axios';
export default {
	async init() {
		return axios.get('/merkantil/calculator/vehicle-leasing/init');
	},
	generateCaptcha() {
		return axios.get('/merkantil/captcha/generate', {
			params: {
				captchaId: 'MERKANTIL_VL_CALCULATOR'
			}
		});
	},
	submit(data) {
		return axios.post('/merkantil/calculator/vehicle-leasing', data);
	}
};
